import { Component, Input } from "@angular/core";
import { PropertiesSettings } from "src/app/core/configuration/properties-settings";
import { Controparte } from "../../../models/controparte";

@Component({
  selector: "app-dati-generali-anagrafiche",
  templateUrl: "dati-generali-anagrafiche.component.html",
})
export class DatiGeneraliAnagraficheComponent {
  @Input() controparte: Controparte;
  @Input() isPartiSearch: boolean;
  @Input() hideOtherData: boolean;
  @Input() isFascicoloSanitario: boolean = false;

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  isPersonaFisica():boolean{
    return !!(this.controparte.parte.tipoPersona && this.controparte.parte.tipoPersona.label === this.PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA);
  }

  // !FABRIZIO
  listaSocieta: any[] = [
    {
      societa: "pippo",
      carica: "pippo",
      dataDal: new Date().valueOf(),
      dataAl: new Date().valueOf(),
      incaricoRimosso: true,
      percPartecipazione: 12.21,
      fiscale: "pippo",
      reaSocieta: "pippo",

      visureCamerali: [
        {
          codiceVisura: "pippo",
          descrizioneVisura: "pippo",
        },
      ],

      anniInteressati: [
        {
          annoComunicazione: 2000,
          annoAnnullato: 2000,
          codiceCausale: "pippo",
          descrizioneCausale: "pippo",
        },
      ],

      certificati: [
        {
          codiceDocumento: "pippo",
          documentiRichiesti: true,
          documentiArrivati: true,
          documentiIncompleti: true,
          descrizioneCertificato: "pippo",
          dataRichiesta: new Date().valueOf(),
          numSollecitiInviati: 2000,
          numProtocolloEntrata: "pippo",
          dataProtocolloEntrata: new Date().valueOf(),
        },
      ],
    },
  ];
}
